var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutoffacility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40-120v-720h560v720H367.33v-166.67h-94V-120H40Zm66.67-66.67h100v-166.66H434v166.66h99.33v-586.66H106.67v586.66Zm100-260h66.66v-66.66h-66.66v66.66Zm0-160h66.66v-66.66h-66.66v66.66Zm160 160h66.66v-66.66h-66.66v66.66Zm0-160h66.66v-66.66h-66.66v66.66Zm422.66 257.34L742.67-396l49.66-50.67H640v-66.66h152.33L742.67-564l46.66-46.67L920-480 789.33-349.33ZM206.67-186.67v-166.66H434v166.66-166.66H206.67v166.66Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutoffacility);
export default __webpack_public_path__ + "static/media/outoffacility.dea1e6a564d1c9e39f619d108b74321b.svg";
export { ForwardRef as ReactComponent };